import React from 'react';
import { useTranslation } from 'react-i18next';
import { GrowthCurveChart } from './GrowthCurveChart';
import type { LifecyclePrediction } from './types';
import css from './DigitalTwinView.module.css';

export type DigitalTwinForecastChartProps = {
  prediction: LifecyclePrediction;
};

export const DigitalTwinForecastChart: React.FC<DigitalTwinForecastChartProps> = ({ prediction }) => {
  const { t } = useTranslation();

  if (prediction.growthCurve.length === 0) {
    return null;
  }

  return (
    <section className={css.forecastSection} aria-labelledby="digital-twin-forecast-heading">
      <div className={css.forecastHeader}>
        <div className={css.forecastTitleBlock}>
          <h3 id="digital-twin-forecast-heading" className={css.forecastTitle}>
            {t('digitalTwin.chartPanelTitle')}
          </h3>
        </div>
        <div className={css.forecastLegend} aria-hidden="true">
          <span className={css.legendItem}>
            <span className={`${css.legendSwatch} ${css.legendSwatchSolid}`} />
            {t('digitalTwin.chart.actual')}
          </span>
          <span className={css.legendItem}>
            <span className={`${css.legendSwatch} ${css.legendSwatchEstimated}`} />
            {t('digitalTwin.chart.estimated')}
          </span>
          <span className={css.legendItem}>
            <span className={`${css.legendSwatch} ${css.legendSwatchProjected}`} />
            {t('digitalTwin.chart.projected')}
          </span>
          <span className={css.legendItem}>
            <span className={`${css.legendSwatch} ${css.legendSwatchTarget}`} />
            {t('digitalTwin.chart.target')}
          </span>
        </div>
      </div>
      <div className={css.chartFrame}>
        <GrowthCurveChart prediction={prediction} className={css.chartCanvas} showLegend={false} />
      </div>
    </section>
  );
};
